import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { markdown } from "../markdown.js";
import { ciTabs } from "./welcome_ci_tabs.js";
import { accessToken } from "./welcome_new_project.js";

const ghaOIDCInstructions = () => markdown`
  Enable the \`id-token: write\` permission in your workflow:

  ${markdown.yaml(`
    permissions:
      contents: read # Required for actions/checkout
      id-token: write # Required for GitHub OIDC

    steps:
      - uses: actions/checkout@v4
      - name: Run Playwright tests
        run: npx playwright test
  `, `.github/workflows/playwright.yml`, { ins: [[1, 3]] })}
`;

const gitlabOIDCInstructions = (project: WireTypes.Project) => markdown`
  GitLab mints the ID token when the job starts, so declare one named \`FLAKINESS_ID_TOKEN\` with your project as its audience:

  ${markdown.yaml(`
    test:
      id_tokens:
        FLAKINESS_ID_TOKEN:
          aud: ${project.org.orgSlug}/${project.projectSlug} # Required for GitLab OIDC
      script:
        - npx playwright test
  `, `.gitlab-ci.yml`, { ins: [[2, 4]] })}
`;

const otherCIInstructions = (project: WireTypes.Project) => markdown`
  Set the \`FLAKINESS_ACCESS_TOKEN\` environment variable to ${accessToken(project)} and run your tests:

  ${markdown.bash(`
    FLAKINESS_ACCESS_TOKEN=<token> npx playwright test
  `)}
`;

export const welcome_playwright = (project: WireTypes.Project) => markdown`

1. Install the Flakiness.io Playwright reporter:

    ${markdown.bash(`
      npm i -D @flakiness/playwright
    `)}

1. Add Flakiness.io Playwright Reporter to the \`playwright.config.ts\` file:

    ${markdown.ts(`
      import { defineConfig } from '@playwright/test';

      export default defineConfig({
        reporter: [
          ['@flakiness/playwright', { flakinessProject: '${project.org.orgSlug}/${project.projectSlug}' }],
        ],
      });
    `, `playwright.config.ts`, { ins: [[4, 6]] })}

1. Configure your CI
    ${ciTabs({
      idPrefix: 'pw',
      project,
      githubActions: ghaOIDCInstructions(),
      gitlabCI: gitlabOIDCInstructions(project),
      otherCI: otherCIInstructions(project),
    })}
`;
